export default __webpack_public_path__ + "images/GK.2529a24.png";